//配置路由相关信息
import Vue from 'vue'
import VueRouter from 'vue-router'
import _string from "@/utils/_string";
import _object from "@/utils/_object";

//通过vue.use(插件)，安装插件
Vue.use(VueRouter)

//创建路由对象
const routes = []

//注册路由函数
const _register_rule = function (path) {
    //去除间隔符
    let component = _string.trim_separator(path, '/')

    let rule = {}
    rule.path = path
    rule.component = (resolve) => require([`../views/${component}`], resolve)
    routes.push(rule)
}

//注册路由

// 一级页面
// 车展
_register_rule('/autoshow/common')

// 台州、验证码
_register_rule('/autoshow/commonsms')
//广州 无letter
_register_rule('/autoshow/guangzhou')
//广州 无letter 加短信验证
_register_rule('/autoshow/guangzhousms')
// 车展 - 无图无字母
_register_rule('/autoshow/noletter')
//太原集团团购会
_register_rule('/autoshow/taiyuan')
//只有姓名手机号
_register_rule('/autoshow/commonfield')
//只有手机号
_register_rule('/autoshow/mobile')

//车型放在弹框中
_register_rule('/autoshow/sub_common')


//新版落地页
_register_rule('/autoshow/common_new')
_register_rule('/autoshow/guangzhou_new')
_register_rule('/autoshow/ulanqab') // 乌兰察布 车展+家博会



// 二手车基本
_register_rule('/usedcar/common')
//抖音 二手车
_register_rule('/usedcar/dycommon')
// 二手车之家
_register_rule('/usedcar/autohome')
//之家 - 无验证码
_register_rule('/usedcar/autohomesms')

// 单品
_register_rule('/single/common')
// 单品 九五众信
_register_rule('/single/zhongxin')
//单品 -昊铂（车型）
_register_rule('/single/atb')
//单品 -广汽本田
_register_rule('/single/bentian')



//多品
_register_rule('/multiple/common')
//抖音 新车 多品
_register_rule('/multiple/dycommon')
_register_rule('/multiple/youjia')
_register_rule('/multiple/linkedform')

// 其他展会
_register_rule('/show/common')
// 表单不同公共 - 石家庄
_register_rule('/show/sjz')
// 展会 -- 汽配展
_register_rule('/show/autoparts')
//家博会 - 日照
_register_rule('/show/rizhao')
//展会 - 泉州
_register_rule('/show/quanzhou')
// 阜阳 - 带验证码
_register_rule('/show/commonsms')
// 至善整装
_register_rule('/show/zhishan')
// 安庆 - B端招商
_register_rule('/show/anqing')
// 博瑞
_register_rule('/show/borui')
//仿蓝装 弹框报名
_register_rule('/show/fanglz')
//橙子建站二级页面
_register_rule('/show/jianzhancommon')
//石家庄年货节
_register_rule('/show/goodsfestival')
//邢台年货节纯图片
_register_rule('/show/picture')
//昆明景博会 /京津冀景博会
_register_rule('/show/jingboexpo')
//京津冀药博会
_register_rule('/show/pharmaceuticalexpo')
//童博会
_register_rule('/show/childarea')
//2025(秋季)首届广州国际汽车产业出口展览会
_register_rule('/show/guangzhou')
//仿蓝装 邀请函
_register_rule('/show/invite')


//新版落地页--展会
_register_rule('/show/common_new')
_register_rule('/show/common_new_phone')



// 二级页面
// 报名成功
_register_rule('/success/success')
// 提示成功页
_register_rule('/success/notice')
// 帮朋友报名
_register_rule('/success/friend')
// 邮寄门票和二手车补充
_register_rule('/success/ticket')
// 置换二手车
_register_rule('/success/replace')
// 二维码
_register_rule('/success/qrcode')

//橙子建站的成功页面
_register_rule('/success/jianzhan')
//橙子建站的展会分享 - 三级页面
_register_rule('/success/showshare')
//橙子建站的报名成功 （三级页面）
_register_rule('/success/showtip')



//小程序
// svip
_register_rule('/mini/svip')
_register_rule('/mini/checksvip')
// 电子票
_register_rule('/mini/ticket')
//核销订单
_register_rule('/mini/order')


const router = new VueRouter(
    {
        //配置路由和组建之间的应用关系
        mode: 'history',
        base: process.env.BASE_URL,
        routes
    }
)

export default router
